import styles from './sign-up-link.module.css';
import { Link, LinkProps } from '../link/link';

export const SignUpLink = (props: LinkProps) => (
  <div className={styles.wrapper}>
    <Link {...props} />
  </div>
);
